import React, { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import "../OutstandingReport/OutstandingReport.css";
import DatePicker from "react-datepicker";
import ReportTable from "../ReportTable";
import totalOutstanding from "../../../../common/assets/images/notification-box.png";
import highPriority from "../../../../common/assets/images/highPriority.png";
import calendar from "../../../../common/assets/images/calendar.png";
import hourglass from "../../../../common/assets/images/hourglass.png";
import usersreport from "../../../../common/assets/images/usersreport.png";
import exportVector from "../../../../common/assets/images/exportVector.png";
import applycheck from "../../../../common/assets/images/applycheck.png";
import clearAllFilter from "../../../../common/assets/images/clearAllFilter.png";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchExportToExcelData,
  fetchOutstandingReportData,
} from "../redux/ReportsSlice";
import { format, parse } from "date-fns";
import Skeleton from "react-loading-skeleton";
import { Tooltip } from "@mui/material";
const OutstandingReport = () => {
  const dispatch = useDispatch();
  const [episodes, setEpisodes] = useState([]);
  const [outstandingPageNumber, setOutstandingPageNumber] = useState(1);
  const [searchText, setSearchText] = useState("");
  const outstandingReportTableData = useSelector(
    (state) => state.outstandingreport.outstandingReportTableData
  );
  const loadingOutstandingReportTableData = useSelector(
    (state) => state.outstandingreport.loadingOutstandingReportTableData
  );
  const filtersForReport = useSelector(
    (state) => state.outstandingreport.filtersForReport
  );
  const loadingFiltersForReport = useSelector((state) => {
    state.outstandingreport.loadingFiltersForReport;
  });
  const loadingExportToExcelData = useSelector(
    (state) => state.outstandingreport.loadingExportToExcelData
  );

  const [specialitySearch, setSpecialitySearch] = useState({
    speciality: "",
    priority: "",
    assign_coder: "",
    episode_type: "",
    current_queue: "",
    status: "",
    days_of_outstanding: "",
  });
  const [selectedFilters, setSelectedFilters] = useState({
    admission_from_date: null,
    admission_to_date: null,
    discharge_from_date: null,
    discharge_to_date: null,
    speciality: [],
    priority: [],
    days_of_outstanding: [],
    assign_coder: [],
    current_queue: [],
    status: [],
  });

  const dateFormat = "dd-MM-yyyy";
  const outstandingWidgets = [
    {
      widgetname: "Total Outstanding",
      count: outstandingReportTableData?.cards?.total_outstanding_episodes,
      color: "#EFF6FF",
      image: totalOutstanding,
    },
    {
      widgetname: "High Priority",
      count: outstandingReportTableData?.cards?.high_priority,
      color: "#FEF2F2",
      image: highPriority,
    },
    {
      widgetname: "30+ Days Old",
      count: outstandingReportTableData?.cards?.["30_days_or_old"],
      color: "#FEFCE8",
      image: calendar,
    },
    {
      widgetname: "Avg Days Outstanding",
      count:
        outstandingReportTableData?.cards?.["avg._days_of_outstanding"].toFixed(
          4
        ),
      color: "#ECFDF5",
      image: hourglass,
    },
    {
      widgetname: "Unassigned",
      count: outstandingReportTableData?.cards?.unassigned_coder,
      color: "#EBEBEB",
      image: usersreport,
    },
  ];
  const toggleSelect = (type, value) => {
    setSelectedFilters((prev) => {
      const alreadySelected = prev[type].includes(value);

      return {
        ...prev,
        [type]: alreadySelected
          ? prev[type].filter((item) => item !== value)
          : [...prev[type], value],
      };
    });
  };
  const handleOustandingFilterApply = () => {
    dispatch(
      fetchOutstandingReportData({
        pageNumber: outstandingPageNumber,
        selectedFilters,
      })
    )
      .unwrap()
      .then((res) => {
        setEpisodes(res.episodes);
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  const handleClearAllFilters = () => {
    setSelectedFilters({
      admission_from_date: null,
      admission_to_date: null,
      discharge_from_date: null,
      discharge_to_date: null,
      speciality: [],
      priority: [],
      days_of_outstanding: [],
      assign_coder: [],
      current_queue: [],
      status: [],
    });

    // refetching without filters
    dispatch(
      fetchOutstandingReportData({
        pageNumber: outstandingPageNumber,
        selectedFilters: {},
      })
    )
      .unwrap()
      .then((res) => setEpisodes(res.episodes))
      .catch((err) => console.error("Error:", err));
  };
  const formatCalenderDateDDMMYYY = (date) =>
    date ? format(date, "dd-MM-yyyy") : null;
  const handleOutstandingReportExport = () => {
    dispatch(
      fetchExportToExcelData({ search_term: searchText, ...selectedFilters })
    )
      .unwrap()
      .then((res) => {
        const fileUrl = res.download_url;
        if (fileUrl) {
          const link = document.createElement("a");
          link.href = fileUrl;
          link.setAttribute("download", "auditfile.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.log("file URL not found in reposne");
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <>
      <div className="outstanding-filters-section mt-3 px-2">
        <h4 className="pb-2">Outstanding Coding Report</h4>
        <div className="row justify-content-between">
          <div className="col-12 col-sm-6 col-md-9">
            <div className="d-flex gap-2">
              {outstandingWidgets.map((eachWidget) => {
                return (
                  <div
                    className="outstanding-widget"
                    style={{ background: eachWidget.color }}
                  >
                    <div>
                      <p>{eachWidget.widgetname}</p>
                      {loadingOutstandingReportTableData ? (
                        <Skeleton />
                      ) : (
                        <p>{eachWidget.count}</p>
                      )}
                    </div>
                    <div>
                      <img src={eachWidget.image} alt={eachWidget.widgetname} />
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="outstanding-details-wrapper">
              <div className="title-export-wrapper">
                <p className="font-size-small fw-semibold mb-0">
                  Outstanding Episodes Detail
                </p>
                <button
                  className="outstanding-export-btn"
                  onClick={handleOutstandingReportExport}
                >
                  {loadingExportToExcelData
                    ? "Downloading..."
                    : "Export to Excel"}
                  <img src={exportVector} alt="exportToExcel" />
                </button>
              </div>
              <ReportTable
                episodes={episodes}
                setEpisodes={setEpisodes}
                outstandingPageNumber={outstandingPageNumber}
                setOutstandingPageNumber={setOutstandingPageNumber}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                searchText={searchText}
                setSearchText={setSearchText}
              />
            </div>
          </div>
          <div className="filter-wrapper-section -scrol col-6 col-md-3">
            <div className="d-flex justify-content-between align-items-center">
              <p className="font-size-small fw-semibold mb-0">
                Filter & Search Criteria
              </p>
              <Tooltip title="Clear All">
                <img
                  src={clearAllFilter}
                  alt="clearAllFilter"
                  style={{ height: "24px", cursor: "pointer" }}
                  onClick={handleClearAllFilters}
                />
              </Tooltip>
            </div>
            <div className="d-flex gap-2 pt-2 flex-column">
              {/* <div className="each-filter-wrapper">
                <label>Campus/Site</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Sites
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          // value={codersSearchValue}
                          // onChange={(e) =>
                          //   setCodersSearchValue(e.target.value)
                          // }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        <Form.Check
                          // key={item}
                          type="checkbox"
                          className="workflow-him-dropdown-menu-options"
                          // label={item.user_name}
                          // value={item.user_id}

                          // onChange={() =>
                          //   handleHimSelectChange(
                          //     "coders",
                          //     item.user_id
                          //   )
                          // }
                        />
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div className="each-filter-wrapper">
                <div className="d-flex gap-1">
                  <div className="w-50">
                    <label>Admission From Date</label>
                    <DatePicker
                      selected={
                        selectedFilters.admission_from_date
                          ? parse(
                              selectedFilters.admission_from_date,
                              "dd-MM-yyyy",
                              new Date()
                            )
                          : null
                      }
                      dateFormat={dateFormat}
                      showYearDropdown
                      yearDropdownItemNumber={150}
                      scrollableYearDropdown
                      maxDate={
                        selectedFilters.admission_to_date
                          ? parse(
                              selectedFilters.admission_to_date,
                              "dd-MM-yyyy",
                              new Date()
                            )
                          : null
                      }
                      onChange={(date) =>
                        setSelectedFilters((prev) => ({
                          ...prev,
                          admission_from_date: formatCalenderDateDDMMYYY(date),
                        }))
                      }
                      placeholderText="Admission From Date"
                      className="outstanding-filter-date-picker"
                    />
                  </div>
                  <div className="w-50">
                    {" "}
                    <label>Admission To Date</label>
                    <div
                      className={`${
                        !selectedFilters.admission_from_date
                          ? "datepicker-tooltip"
                          : ""
                      }`}
                      data-title={
                        "'To date' cannot be selected until 'From date' is selected"
                      }
                    >
                      <DatePicker
                        selected={
                          selectedFilters.admission_to_date
                            ? parse(
                                selectedFilters.admission_to_date,
                                "dd-MM-yyyy",
                                new Date()
                              )
                            : null
                        }
                        disabled={!selectedFilters.admission_from_date}
                        dateFormat={dateFormat}
                        showYearDropdown
                        yearDropdownItemNumber={150}
                        scrollableYearDropdown
                        minDate={
                          selectedFilters.admission_from_date
                            ? parse(
                                selectedFilters.admission_from_date,
                                "dd-MM-yyyy",
                                new Date()
                              )
                            : null
                        }
                        onChange={(date) =>
                          setSelectedFilters((prev) => ({
                            ...prev,
                            admission_to_date: formatCalenderDateDDMMYYY(date),
                          }))
                        }
                        placeholderText="Admission To Date"
                        className="outstanding-filter-date-picker"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="each-filter-wrapper">
                <div className="d-flex gap-1">
                  <div className="w-50">
                    <label>Discharge From Date</label>
                    <DatePicker
                      selected={
                        selectedFilters.discharge_from_date
                          ? parse(
                              selectedFilters.discharge_from_date,
                              "dd-MM-yyyy",
                              new Date()
                            )
                          : null
                      }
                      dateFormat={dateFormat}
                      showYearDropdown
                      yearDropdownItemNumber={150}
                      scrollableYearDropdown
                      maxDate={
                        selectedFilters.discharge_to_date
                          ? parse(
                              selectedFilters.discharge_to_date,
                              "dd-MM-yyyy",
                              new Date()
                            )
                          : null
                      }
                      onChange={(date) =>
                        setSelectedFilters((prev) => ({
                          ...prev,
                          discharge_from_date: formatCalenderDateDDMMYYY(date),
                        }))
                      }
                      placeholderText="Discharge From Date"
                      className="outstanding-filter-date-picker"
                    />
                  </div>
                  <div className="w-50">
                    <label>Discharge To Date</label>
                    <div
                      className={`${
                        !selectedFilters.admission_from_date
                          ? "datepicker-tooltip"
                          : ""
                      }`}
                      data-title={
                        "'To date' cannot be selected until 'From date' is selected"
                      }
                    >
                      <DatePicker
                        selected={
                          selectedFilters.discharge_to_date
                            ? parse(
                                selectedFilters.discharge_to_date,
                                "dd-MM-yyyy",
                                new Date()
                              )
                            : null
                        }
                        dateFormat={dateFormat}
                        showYearDropdown
                        yearDropdownItemNumber={150}
                        disabled={!selectedFilters.discharge_from_date}
                        scrollableYearDropdown
                        minDate={
                          selectedFilters.discharge_from_date
                            ? parse(
                                selectedFilters.discharge_from_date,
                                "dd-MM-yyyy",
                                new Date()
                              )
                            : null
                        }
                        onChange={(date) =>
                          setSelectedFilters((prev) => ({
                            ...prev,
                            discharge_to_date: formatCalenderDateDDMMYYY(date),
                          }))
                        }
                        placeholderText="Discharge To Date"
                        className="outstanding-filter-date-picker"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="each-filter-wrapper">
                <label>Speciality</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Specialities
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          value={specialitySearch.speciality}
                          onChange={(e) =>
                            setSpecialitySearch((prev) => ({
                              ...prev,
                              speciality: e.target.value,
                            }))
                          }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.speciality
                            ?.filter((item) =>
                              item
                                ?.toLowerCase()
                                .includes(
                                  (
                                    specialitySearch.speciality || ""
                                  ).toLowerCase()
                                )
                            )

                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                checked={selectedFilters.speciality.includes(
                                  item
                                )}
                                onChange={() =>
                                  toggleSelect("speciality", item)
                                }
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="each-filter-wrapper">
                <label>Priority Level</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Priorities
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          value={specialitySearch.priority}
                          onChange={(e) =>
                            setSpecialitySearch((prev) => ({
                              ...prev,
                              priority: e.target.value,
                            }))
                          }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.priority
                            ?.filter((item) =>
                              item
                                ?.toLowerCase()
                                .includes(
                                  (
                                    specialitySearch.priority || ""
                                  ).toLowerCase()
                                )
                            )

                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                checked={selectedFilters.priority.includes(
                                  item
                                )}
                                onChange={() => toggleSelect("priority", item)}
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="each-filter-wrapper">
                <label>Days Outstanding</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          value={specialitySearch.days_of_outstanding}
                          onChange={(e) =>
                            setSpecialitySearch((prev) => ({
                              ...prev,
                              days_of_outstanding: e.target.value,
                            }))
                          }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.days_of_outstanding
                            ?.filter((item) =>
                              item
                                .toString()
                                ?.toLowerCase()
                                .includes(
                                  (
                                    specialitySearch.days_of_outstanding || ""
                                  ).toLowerCase()
                                )
                            )

                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                checked={selectedFilters?.days_of_outstanding.includes(
                                  item
                                )}
                                onChange={() =>
                                  toggleSelect("days_of_outstanding", item)
                                }
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {/* <div className="each-filter-wrapper">
                <label>Episode Type</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Types
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          // value={codersSearchValue}
                          // onChange={(e) =>
                          //   setCodersSearchValue(e.target.value)
                          // }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.episode_type
                            ?.filter((item) =>
                              item
                                ?.toLowerCase()
                                .includes(
                                  specialitySearch.episode_type?.toLowerCase()
                                )
                            )
                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                // checked={selected.includes(item)}
                                onChange={() => toggleSelect(item)}
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div className="each-filter-wrapper">
                <label>Assigned Coders</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Coders
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          value={specialitySearch.assign_coder}
                          onChange={(e) =>
                            setSpecialitySearch((prev) => ({
                              ...prev,
                              assign_coder: e.target.value,
                            }))
                          }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.assign_coder
                            ?.filter((item) =>
                              item
                                ?.toLowerCase()
                                .includes(
                                  specialitySearch.assign_coder?.toLowerCase()
                                )
                            )
                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                checked={selectedFilters.assign_coder.includes(
                                  item
                                )}
                                onChange={() =>
                                  toggleSelect("assign_coder", item)
                                }
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="each-filter-wrapper">
                <label>Current Queue</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Current Queue
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          value={specialitySearch.current_queue}
                          onChange={(e) =>
                            setSpecialitySearch((prev) => ({
                              ...prev,
                              current_queue: e.target.value,
                            }))
                          }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.current_queue
                            ?.filter((item) =>
                              item
                                ?.toLowerCase()
                                .includes(
                                  specialitySearch.current_queue?.toLowerCase()
                                )
                            )
                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                checked={selectedFilters.current_queue.includes(
                                  item
                                )}
                                onChange={() =>
                                  toggleSelect("current_queue", item)
                                }
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="each-filter-wrapper">
                <label>Status</label>
                <Dropdown className="outstanding-filter-card-dropdown">
                  <Dropdown.Toggle
                    id="coders"
                    className="outstanding-filter-card-label"
                  >
                    All Status
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="outstanding-filter-select">
                    <div>
                      <div>
                        <input
                          className="outstanding-filter-dropdown-search-input"
                          type="text"
                          value={specialitySearch.status}
                          onChange={(e) =>
                            setSpecialitySearch((prev) => ({
                              ...prev,
                              status: e.target.value,
                            }))
                          }
                          placeholder="Search"
                        />
                      </div>
                      <div className="outstading-filter-dropdown-options-container">
                        {loadingFiltersForReport ? (
                          <p>Loading..</p>
                        ) : (
                          filtersForReport?.status
                            ?.filter((item) =>
                              item
                                ?.toLowerCase()
                                .includes(
                                  specialitySearch.status?.toLowerCase()
                                )
                            )
                            .map((item) => (
                              <Form.Check
                                key={item}
                                type="checkbox"
                                label={item}
                                value={item}
                                checked={selectedFilters.status.includes(item)}
                                onChange={() => toggleSelect("status", item)}
                              />
                            ))
                        )}
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className="outstanding-filters-btn-wrraper">
                {/* <button onClick={handleOustandingFilterApply}>
                  Apply Filters
                  <img src={applycheck} alt="applycheck" />
                </button> */}
                {/* <button onClick={handleClearAllFilters}>
                  Clear All <img src={clearAll} alt="clearAll" />
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OutstandingReport;
